module.exports = __webpack_public_path__ + "static/img/bj_favicon.9c5814c.png";